import { createSelector } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { IStoreState } from "../../../../reducers/types";
import { TravelWalletOffer } from "redmond";

export const getFetchTravelWalletDetailsCallState = (state: IStoreState) =>
  state.experiencesTravelWallet.fetchTravelWalletDetailsCallState;

export const getTravelWalletOffers = (state: IStoreState) =>
  state.experiencesTravelWallet.offers;

export const getActiveTravelWalletOffers = createSelector(
  getTravelWalletOffers,
  (offers) => {
    return offers.filter((offer) => {
      return dayjs().isAfter(dayjs(offer?.saleEventStartOn));
    });
  }
);

export const getTravelWalletCredit = (state: IStoreState) =>
  state.experiencesTravelWallet.credit;

export const getCreditBreakdown = (state: IStoreState) =>
  state.experiencesTravelWallet.creditBreakdown;

export const getTravelCreditsHistoryTransaction = (state: IStoreState) =>
  state.experiencesTravelWallet.creditsHistoryTransactions;

export const getPartialHistoryValidFromTime = (state: IStoreState) =>
  state.experiencesTravelWallet.partialHistoryValidFromTime;

export const getActiveCrossSellOffers = createSelector(
  getTravelWalletOffers,
  (travelWalletOffers): TravelWalletOffer[] => {
    const activeCrossSellOffers = travelWalletOffers.filter((offer) => {
      return offer.imageId && offer.imageId.startsWith("CrossSellOffer");
    });
    return activeCrossSellOffers;
  }
);
